<template>
  <div class="text-center mb-8">
    <h2 class="text-2xl md:text-3xl font-bold text-primary mb-3">
      +1 milhão de pessoas
    </h2>
    <p class="text-gray-600">
      descobriram seu propósito através da <br> numerologia pitagórica
    </p>
  </div>
</template>